module.exports = __webpack_public_path__ + "img/bk.6a146834.png";